import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { UsageScreenProvider, useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { SearchResultViewTracker, getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback, useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { EcosystemCardSmall } from 'trellis-ecosystem';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { getInstalledByCard, getProductTypeByCard, getRecommendationTypeByCard, getSourceIdByCard } from '../../utils/usageTracker';
import { CollectionCard } from './CollectionCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CollectionSection(props) {
  return /*#__PURE__*/_jsx(UsageScreenProvider, {
    subscreen: Subscreens.COLLECTION_SECTION,
    children: /*#__PURE__*/_jsx(CollectionSectionContent, Object.assign({}, props))
  });
}
function CollectionSectionContent({
  buttonText,
  cards,
  collectionId,
  collectionSlug,
  description,
  href,
  productType,
  queryType,
  sectionCount,
  sectionIndex,
  title
}) {
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      lg: false
    }
  });
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const collectionIdNumber = typeof collectionId === 'number' ? collectionId : undefined;
  const searchResultEventProps = useMemo(() => ({
    listingId: collectionIdNumber,
    resultCount: sectionCount,
    resultIndex: sectionIndex,
    resultType: 'COLLECTION',
    slug: collectionSlug,
    type: productType
  }), [collectionIdNumber, collectionSlug, productType, sectionCount, sectionIndex]);
  const trackButtonClicked = useCallback(() => {
    trackMarketplaceEvent(getSearchResultClickedEvent(searchResultEventProps));
  }, [trackMarketplaceEvent, searchResultEventProps]);
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-test-id": "collection-section",
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Grid, {
        rowGap: "800",
        children: [/*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, searchResultEventProps, {
            children: /*#__PURE__*/_jsx(CollectionCard, {
              buttonText: buttonText,
              description: description,
              href: href,
              name: title,
              onClick: trackButtonClicked,
              removeCardWrapper: true,
              slug: collectionSlug,
              previewItems: isMobile ? cards.map(card => ({
                listingId: card.listingId,
                iconUrl: card.iconUrl,
                name: card.listingName
              })) : undefined,
              totalItemCount: isMobile ? cards.length : 0
            })
          }))
        }), !isMobile && /*#__PURE__*/_jsx(GridItem, {
          size: {
            xs: 12,
            lg: 6
          },
          children: /*#__PURE__*/_jsx(Grid, {
            rowGap: "800",
            children: cards.map((card, index) => /*#__PURE__*/_jsx(GridItem, {
              size: {
                xs: 12,
                md: 4,
                lg: 6
              },
              children: /*#__PURE__*/_jsx(CollectionListingCard, {
                card: card,
                collectionId: collectionIdNumber,
                collectionSlug: collectionSlug,
                queryType: queryType,
                resultCount: cards.length,
                resultIndex: index
              })
            }, card.listingId))
          })
        })]
      })
    })
  });
}
function CollectionListingCard({
  card,
  collectionId,
  collectionSlug,
  queryType,
  resultCount,
  resultIndex
}) {
  var _card$companyName, _card$iconUrl, _card$listingName, _getProductTypeByCard;
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const searchResultEventProps = useMemo(() => ({
    category: collectionSlug,
    collectionId,
    companyName: card.companyName,
    componentType: 'EcosystemCardSmall',
    installed: getInstalledByCard(card),
    listingId: collectionId,
    queryType,
    recommendationType: getRecommendationTypeByCard(card),
    resultCount,
    resultIndex,
    resultType: 'COLLECTION',
    slug: collectionSlug,
    sourceId: getSourceIdByCard(card),
    type: getProductTypeByCard(card)
  }), [card, collectionId, collectionSlug, queryType, resultCount, resultIndex]);
  return /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, searchResultEventProps, {
    children: /*#__PURE__*/_jsx(EcosystemCardSmall, {
      companyName: (_card$companyName = card.companyName) !== null && _card$companyName !== void 0 ? _card$companyName : '',
      imageSrc: (_card$iconUrl = card.iconUrl) !== null && _card$iconUrl !== void 0 ? _card$iconUrl : '',
      linkMode: "react-router",
      listingHref: card.slug ? generatePath(Paths.LISTING_DETAILS, {
        listingSlug: card.slug
      }) : undefined,
      name: (_card$listingName = card.listingName) !== null && _card$listingName !== void 0 ? _card$listingName : '',
      onClick: () => trackMarketplaceEvent(getSearchResultClickedEvent(searchResultEventProps)),
      productType: (_getProductTypeByCard = getProductTypeByCard(card)) !== null && _getProductTypeByCard !== void 0 ? _getProductTypeByCard : 'APP'
    })
  }));
}